import { styled } from "@mui/material";
import { ComponentType } from "react";
import { mediaQueryDownStyle } from "../util/use-breakpoint";
import { IWithThemeProps } from "./default.theme";

export const withStyledMarkdown = <T>(component: ComponentType<T>) =>
    styled(component)(({ theme }: IWithThemeProps) => ({
        "*": {
            marginBottom: 0,
        },
        "& > :first-of-type:not(style):not(:first-of-type ~ *), & > style + *":
            {
                marginTop: 0,
            },
        h6: {
            color: theme?.palette.text.secondary,
            fontSize: 12,
            fontWeight: 300,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(2),
        },
        h5: {
            fontSize: 20,
            lineHeight: 1.4,
            fontWeight: 600,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(2),
        },
        h4: {
            fontSize: 32,
            lineHeight: 1.25,
            fontWeight: 400,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(2),
        },
        h3: {
            fontSize: 40,
            lineHeight: 1.2,
            fontWeight: 600,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(2),
        },
        h2: {
            fontSize: 56,
            lineHeight: 1.11,
            fontWeight: 600,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(2),
        },
        h1: {
            fontSize: 64,
            lineHeight: 1.09,
            fontWeight: 600,
            padding: 0,
            margin: 0,
            marginTop: theme?.spacing(2),
            marginBottom: theme?.spacing(4),
        },
        "p, li": {
            fontSize: 22,
            lineHeight: 1.36,
            color: theme?.palette.text.secondary,
            fontWeight: 300,
            em: {
                strong: {
                    a: {
                        fontStyle: "normal",
                        backgroundColor: theme?.palette.action.active,
                        color: theme?.palette.background.default,
                        "&:link, &:visited": {
                            color: theme?.palette.background.default,
                        },
                        "&:hover": {
                            color: theme?.palette.action.active,
                            backgroundColor: theme?.palette.background.default,
                            borderColor: theme?.palette.action.active,
                        },
                    },
                },
            },
            strong: {
                a: {
                    textAlign: "center",
                    fontSize: 18,
                    fontWeight: 600,
                    lineHeight: 1.44,
                    borderStyle: "solid",
                    borderWidth: 2,
                    borderColor: theme?.palette.action.active,
                    borderRadius: 20,
                    paddingTop: theme?.spacing(1),
                    paddingBottom: theme?.spacing(1),
                    paddingLeft: theme?.spacing(2),
                    paddingRight: theme?.spacing(2),
                    textDecoration: "none",
                    textTransform: "uppercase",
                    display: "inline-block",
                    transition: "background-color 250ms",
                    "&:hover": {
                        backgroundColor: theme?.palette.action.active,
                        color: theme?.palette.background.default,
                        borderColor: theme?.palette.action.active,
                    },
                },
            },
        },
        ul: {
            marginTop: theme?.spacing(1),
            paddingLeft: theme?.spacing(2),
            li: {
                paddingLeft: theme?.spacing(1),
            },
            "li:not(:last-child)": {
                marginBottom: theme?.spacing(1),
            },
            "li::marker": {
                content: "'\\b7'",
            },
        },
        blockquote: {
            margin: 0,
            p: {
                color: theme?.palette.text.primary,
                fontWeight: 400,
            },
        },
        a: {
            "&:link, &:visited": {
                color: theme?.palette.action.active,
            },
        },
        img: {
            maxWidth: "100%",
            height: "auto",
        },

        ...mediaQueryDownStyle(theme, "md", {
            h5: {
                fontSize: 18,
                lineHeight: 1.44,
            },
            h4: {
                fontSize: 24,
                lineHeight: 1.33,
            },
            h3: {
                fontSize: 32,
                lineHeight: 1.25,
            },
            h2: {
                fontSize: 40,
                lineHeight: 1.2,
            },
            h1: {
                fontSize: 48,
                lineHeight: 1.13,
            },
            "p, li": {
                fontSize: 20,
                lineHeight: 1.4,
                strong: {
                    a: {
                        display: "block",
                    },
                },
            },
        }),

        ...mediaQueryDownStyle(theme, "xs", {
            h5: {
                fontSize: 16,
                lineHeight: 1.44,
            },
            h4: {
                fontSize: 18,
                lineHeight: 1.33,
            },
            h3: {
                fontSize: 24,
                lineHeight: 1.25,
            },
            h2: {
                fontSize: 32,
                lineHeight: 1.2,
            },
            h1: {
                fontSize: 40,
                lineHeight: 1.13,
            },
            "p, li": {
                fontSize: 18,
                lineHeight: 1.4,
                strong: {
                    a: {
                        display: "block",
                    },
                },
            },
        }),
    }));
